<div
  class="container"
  data-automation-e2e-selector="economicEventDetailsContainer"
>
  <div class="header">
    <div class="title" data-automation-e2e-selector="economicEventHeader">
      {{ event.name }}
    </div>

    <div class="icons">
      <i
        [ngClass]="['fa', (fullscreen | async) ? 'fa-compress' : 'fa-expand']"
        (click)="toggleFullscreen()"
        data-icon
        data-automation-e2e-selector="expandEconomicEventDetails"
      ></i>
      <i
        class="fa fa-times"
        (click)="closeEvent()"
        data-icon
        data-automation-e2e-selector="closeEconomicEventDetails"
      ></i>
    </div>
  </div>

  <div
    class="releaseDate"
    data-automation-e2e-selector="economicEventReleaseDate"
  >
    Released on {{ releaseString() }}
    <span
      *ngIf="event.releaseFor && event.releaseFor.length"
      data-automation-e2e-selector="economicEventReleasedForDate"
    >
      for {{ event.releaseFor }}
    </span>
  </div>

  <div class="values" *ngIf="event.values.length">
    <muni-gameday-value-table [event]="event"> </muni-gameday-value-table>
  </div>

  <div class="description" *ngIf="event.highlights && event.highlights.length">
    <h3 data-automation-e2e-selector="economicEventHighlightsHeader">
      Highlights
    </h3>
    <div
      data-automation-e2e-selector="economicEventHighlightsBody"
      [innerHTML]="event.highlights"
    ></div>
  </div>

  <div
    class="description"
    *ngIf="event.description && event.description.length"
  >
    <h3 data-automation-e2e-selector="economicEventDescriptionHeader">
      Why Investors Care
    </h3>
    <div
      data-automation-e2e-selector="economicEventDescriptionBody"
      [innerHTML]="event.description"
    ></div>
  </div>

  <div class="description" *ngIf="event.definition && event.definition.length">
    <h3 data-automation-e2e-selector="economicEventDefinitionHeader">
      Definition
    </h3>
    <div
      data-automation-e2e-selector="economicEventDefinitionBody"
      [innerHTML]="event.definition"
    ></div>
  </div>
</div>
